<template>
	<div>
		<el-row class="grant-row" v-for="(grant, index) in grants" :key="`grant-${index}`" :gutter="20">
			<el-col :span="dynamic_span">
				<el-form-item :prop="propGenerator('name', index)" label="Name of Grant" :rules="validation.name">
					<el-input v-model="grant.name"/>
				</el-form-item>
			</el-col>
			<el-col :span="dynamic_span">
				<el-form-item :prop="propGenerator('date_awarded', index)" label="Date Awarded" :rules="validation.date_awarded">
					<el-date-picker class="wide-date" format="M-dd-yyyy" type="date" v-model="grant.date_awarded"/>
				</el-form-item>
			</el-col>
			<el-col :span="dynamic_span">
				<el-form-item :prop="propGenerator('amount', index)" label="Grant Amount" :rules="validation.amount">
					<el-input v-model="grant.amount" v-currency="money"/>
				</el-form-item>
			</el-col>
			<el-col v-if="grants.length > 1" :xs="4" :sm="3">
				<el-button @click="removeGrant(index)" class="delete-button" type="danger" icon="el-icon-delete" circle></el-button>
			</el-col>
		</el-row>
		<el-button class="add-grant-btn" @click="addGrant" type="primary" icon="el-icon-circle-plus-outline
		">Add Grant</el-button>
	</div>
</template>

<script>
import { mapSimpleValidation } from '@/js/utilities/validation-mapper.js';
import { mapMultiRowFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';
import money_mixin from '@/js/mixins/money-mixin.js';
export default{
	mixins: [ money_mixin ],
	computed: {
		...mapMultiRowFields('application/project_budget', ['match_details.grants']),
		dynamic_span(){
			return (this.grants.length > 1) ? 7 : 8;
		},
	},
	methods:{
		...mapActions('application/project_budget', ['addGrant', 'removeGrant']),
		propGenerator: (field, index) => `match_details.grants[${index}].${field}`
	},
	data: () => ({
		validation: {
			...mapSimpleValidation(['name', 'date_awarded', 'amount'])
		}
	})
}
</script>
<style>
@media(min-width:760px){
#printable .printable .grant-row div.el-form-item{
	margin-bottom:10px !important;
}
}
@media(max-width:760px){
	.grant-row{
		padding-bottom:15px;
	}
	.grant-row:not(:first-child){
		border-top:1px solid rgba(0,0,0,.35);
		padding-top:12px;
	}
}

</style>
<style scoped>
.wide-date{
	width:100%;
}
.delete-button{
	margin-top:26px;
}
.add-grant-btn{
	margin-bottom: 25px;
}
</style>
